import { consultationChannels } from '../../assets/consultationOptions';
import { FormField } from './FormField';

export function StepContactInfo({ register, errors }) {
  return (
    <div className="booking-step">
      <div className="booking-step__intro">
        <p className="eyebrow">Step 2</p>
        <h3>Contact Information</h3>
        <p>How should we reach you and prepare for the conversation?</p>
      </div>

      <div className="booking-grid">
        <FormField id="name" label="Name" required error={errors.name?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="text"
              autoComplete="name"
              placeholder="Your full name"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('name')}
            />
          )}
        </FormField>

        <FormField id="company" label="Company" required error={errors.company?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="text"
              autoComplete="organization"
              placeholder="Company or brand name"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('company')}
            />
          )}
        </FormField>

        <FormField id="email" label="Email" required error={errors.email?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="email"
              autoComplete="email"
              placeholder="you@company.com"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('email')}
            />
          )}
        </FormField>

        <FormField id="phone" label="Phone" required error={errors.phone?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="tel"
              autoComplete="tel"
              placeholder="+91 99999 99999"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('phone')}
            />
          )}
        </FormField>

        <FormField id="country" label="Country" required error={errors.country?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="text"
              autoComplete="country-name"
              placeholder="India"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('country')}
            />
          )}
        </FormField>

        <FormField
          id="preferredCommunication"
          label="Preferred Communication"
          required
          error={errors.preferredCommunication?.message}
        >
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('preferredCommunication')}
            >
              <option value="">Select channel</option>
              {consultationChannels.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField
          id="website"
          label="Website"
          className="booking-field--full"
          hint="Optional"
          error={errors.website?.message}
        >
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="url"
              autoComplete="url"
              placeholder="https://yourwebsite.com"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('website')}
            />
          )}
        </FormField>
      </div>
    </div>
  );
}
